import Model, { attr, belongsTo } from '@ember-data/model';
import type { AsyncBelongsTo } from '@ember-data/model';
import type CustomUserDocumentTemplateModel from 'garaje/models/custom-user-document-template';
import type DraftDocumentModel from 'garaje/models/draft-document';
import type LocationModel from 'garaje/models/location';

/**
 * Reserves a draft-document and returns a write-only S3 upload URL. Modeled as its
 * own resource so the create goes through `store.createRecord(...).save()` (custom
 * collection URL via the adapter's `pathForType`) instead of a hand-assembled JSON:API
 * envelope. `contentType` / `byteSize` / `template` / `location` are the create inputs;
 * `uploadLink` and the `draftDocument` linkage come back in the response.
 */
export default class DraftDocumentUploadLink extends Model {
  @attr('string') declare contentType: string;
  @attr('number') declare byteSize: number;
  // Response-only: null for the record's entire pre-save life.
  @attr('string', { defaultValue: null }) declare uploadLink: string | null;

  @belongsTo('custom-user-document-template', { async: true, inverse: null })
  declare template: AsyncBelongsTo<CustomUserDocumentTemplateModel> | CustomUserDocumentTemplateModel;

  @belongsTo('location', { async: true, inverse: null })
  declare location: AsyncBelongsTo<LocationModel> | LocationModel | null;

  @belongsTo('draft-document', { async: true, inverse: null })
  declare draftDocument: AsyncBelongsTo<DraftDocumentModel> | DraftDocumentModel;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'draft-document-upload-link': DraftDocumentUploadLink;
  }
}
